import React, { Component, Fragment } from 'react';

class TextArea extends Component {
  static defaultProps = {
    errors: null,
  };

  state = {
    className: 'input',
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors !== null) {
      this.setState({ className: 'textarea parsley-error' });
    } else {
      this.setState({ className: 'textarea' });
    }
  }

  render() {
    return (
      <Fragment>
        <textarea {...this.props} className={this.state.className}>
          {this.props.children}
        </textarea>

        {this.props.errors !== null && <span className="helper">{this.props.errors.join(', ')}</span>}
      </Fragment>
    );
  }
}

export default TextArea;
